//
//
//
//
//
//
//

import { mapGetters } from 'vuex' 

export default {
  name: 'AssistiveDot',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {

    }
  },

  methods: {
    changeModel () {
      this.$emit('input', true)
    }
  },

  components: {

  }
}



// WEBPACK FOOTER //
// ./src/components/music_player/AssistiveDot.vue